/* eslint-disable no-param-reassign */
// These rule need to be disabled cause the element passed as prop in ref object will be changed to apply the scroll
import React, { RefObject, useEffect, useRef } from "react";

/**
 * use these hook to get the functions to apply the drag horizontal
 * @param ref Pass the element as a ref to be scrollable
 * @param fireOnlyOnDoubleClick if set to true the drag will be applied only on double click
 * @returns function onMouseDown to be applied to the element that you want to fire the drag
 */
function useDragHorizontal(ref: RefObject<HTMLElement>, fireOnlyOnDoubleClick?: boolean){
	const isScrolling = useRef(false);
	const position = useRef({
		left: 0,
		x: 0
	});

	function onMouseDown(e: React.MouseEvent<Element, MouseEvent>){   
		if(!ref.current)
			return;
            
		if(fireOnlyOnDoubleClick && e.detail !== 2)
			return;

		ref.current.style.cursor = "grabbing";
		ref.current.style.userSelect = "none";

		position.current = {
			left: ref.current.scrollLeft,
			x: e.clientX
		};

		isScrolling.current = true;
	}

	function onMouseUp(){  
		if(!ref.current)
			return;
        
		if(!isScrolling.current)
			return;

		ref.current.style.cursor = "auto";
		ref.current.style.userSelect = "auto";
		isScrolling.current = false;
	}

	function onMouseMove(e: MouseEvent){
		if(!ref.current)
			return;
        
		if(!isScrolling.current)
			return;
            
		const dx = e.clientX - position.current.x;
		ref.current.scrollLeft = position.current.left - dx;
	}

	useEffect(() => {
		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("mouseup", onMouseUp);
		return () => {
			document.removeEventListener("mousemove", onMouseMove);
			document.removeEventListener("mouseup", onMouseUp);
		};
	}, []);

	return {
		onMouseDown
	};
}

export default useDragHorizontal;
